import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTopFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-top-full, grid, window"><path d="M20.25 3.75H21V3H20.25V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3V21H3.75V20.25ZM3.75 3.75V3H3V3.75H3.75ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25V3.75H3V20.25H4.5ZM3.75 4.5H20.25V3H3.75V4.5Z" fill="currentColor"/><path d="M20.25 10.5H21V9H20.25V10.5ZM3.75 9H3V10.5H3.75V9ZM3.75 10.5H20.25V9H3.75V10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutTopFull;
